import { Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { firstValueFrom } from 'rxjs';
import { ConfirmComponent, ConfirmDialogData } from '../../shared/dialogs/confirm/confirm.component';
import { DialogService } from '../../shared/components/dialog/dialog.service';
import { CopilotProcessingService } from '../../_services/copilot-processing.service';
import { CopilotDocument } from '../../_interfaces/document';
import { Dictation } from '../../_interfaces/dictation';
import { Template } from '../../_interfaces/template';

@Injectable({ providedIn: 'root' })
export class DocumentSyncService {
  constructor(
    private readonly dialog: DialogService,
    private readonly translate: TranslateService,
    private readonly processing: CopilotProcessingService,
  ) {}

  confirmSync(): Promise<boolean> {
    const ref = this.dialog.open<ConfirmComponent, ConfirmDialogData, boolean>(ConfirmComponent, {
      data: {
        svgIcon: 'update-document',
        title: this.translate.instant('Update document?'),
        description: this.translate.instant(
          'This document will be updated with the latest consultation updates.',
        ),
        warning: this.translate.instant('Any manual changes you made to this document may be lost.'),
        cancelText: this.translate.instant('Cancel'),
        confirmText: this.translate.instant('Update document'),
      },
      presentation: 'dialog',
    });

    return firstValueFrom(ref.afterClosed()).then((confirmed) => !!confirmed);
  }

  sync(dictation: Dictation, document: CopilotDocument): void {
    const template: Template = {
      id: document.templateId,
      type: document.templateType,
      title: document.templateTitle,
      workflow_trigger: document.workflow_trigger,
    };

    this.processing.enqueue(dictation, [template], 'update');
  }
}
